(function () {
  const root = document.getElementById('age-gate');
  if (!root || root.dataset.enabled !== 'true') return;

  const scope = (root.dataset.scope || 'all').toLowerCase();
  const redirectUrl = root.dataset.redirectUrl || '/';
  const onlyTag = (root.dataset.onlyTag || '').trim();
  const onlyTemplates = (root.dataset.onlyTemplates || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean);

  const btnYes = root.querySelector('[data-age-yes]');
  const btnNo = root.querySelector('[data-age-no]');

  const LS_KEY = 'age_verified_fallback';

  function lockPage() {
    root.classList.add('is-open');
    document.documentElement.classList.add('age-gate-locked');
    document.body.classList.add('age-gate-locked');
  }

  function unlockPage() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('age-gate-locked');
    document.body.classList.remove('age-gate-locked');
  }

  function getTemplateName() {
    const cls = Array.from(document.body.classList).find(c => c.indexOf('template-') === 0);
    return cls ? cls.replace('template-', '') : '';
  }

  function pageMatchesScope() {
    if (scope === 'all') return true;

    if (scope === 'templates') {
      const tpl = getTemplateName();
      return tpl && onlyTemplates.includes(tpl);
    }

    if (scope === 'tag') {
      const tpl = getTemplateName();
      if (tpl !== 'product') return false;

      if (!onlyTag) return true;

      const meta = document.querySelector('meta[property="product:tag"]');
      if (meta && meta.content) {
        return meta.content.split(',').map(s => s.trim()).includes(onlyTag);
      }

      const node = document.querySelector('[data-product-tags]');
      if (node) {
        try {
          const tags = JSON.parse(node.textContent || '[]');
          return Array.isArray(tags) ? tags.includes(onlyTag) : true;
        } catch (e) {
          return true;
        }
      }

      return true;
    }

    return true;
  }

  function fallbackIsVerified() {
    try {
      return localStorage.getItem(LS_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function fallbackSetVerified() {
    try {
      localStorage.setItem(LS_KEY, '1');
    } catch (e) {}
  }

  async function safeFetchJson(url, options) {
    try {
      const res = await fetch(url, Object.assign({ credentials: 'same-origin' }, options || {}));
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  async function isCartVerified() {
    const cart = await safeFetchJson('/cart.js');
    if (!cart) return null;
    const attrs = cart.attributes || {};
    return String(attrs.age_verified || '') === '1';
  }

  async function setCartVerified() {
    const updated = await safeFetchJson('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { age_verified: '1' } })
    });
    return !!updated;
  }

  function interceptAddToCart() {
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action || form.action.indexOf('/cart/add') === -1) return;

        if (root.classList.contains('is-open')) {
          e.preventDefault();
          lockPage();
        }
      },
      true
    );
  }

  async function init() {
    if (!pageMatchesScope()) return;
    if (fallbackIsVerified()) return;

    const verified = await isCartVerified();
    if (verified === true) return;

    lockPage();
    interceptAddToCart();
  }

  if (btnYes) {
    btnYes.addEventListener('click', async function () {
      btnYes.disabled = true;
      await setCartVerified();
      fallbackSetVerified();
      btnYes.disabled = false;
      unlockPage();
    });
  }

  if (btnNo) {
    btnNo.addEventListener('click', function () {
      window.location.href = redirectUrl;
    });
  }

  init();
})();